<form class="form-detail-layout" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <tngh-change-password [formControl]="passwordReset" [showFormErrors]="showFormErrors" [isInvalidPassword]="isInvalidPassword"></tngh-change-password>
  <div class="form-detail-layout__navigation">
    <tngh-button type="submit" size="sm-condensed" i18n-label="@@passwordSubmitButton" label="Submit"></tngh-button>
  </div>
</form>
